// deps
import React, { ReactElement, memo, useCallback, useMemo } from "react";
import cx from "classnames";

//styles
import styles from "./IconView.scss";

// interfaces
import { PaymentMethodDef } from "@payment-ui/interfaces";

// components
import { PaymentMethodName } from "@payment-ui/widgets/payment-method-name";
import { PaymentMethodIcon } from "@payment-ui/widgets/payment-method-icon";

// helpers
import { getPaymentMethodIconUrl, getPaymentMethodDisplayName } from "@payment-ui/helpers/Payment";

// testids
import { IconViewTestIdsType } from "@swiggy-private/payment-test-ids";

export interface IconViewProps {
    methodData: PaymentMethodDef;
    onClick: VoidFunction;
    isMethodEnabled: boolean;
    testIds: IconViewTestIdsType;
}

function PaymentMethodIconView(props: IconViewProps): ReactElement {
    const { methodData, onClick, isMethodEnabled, testIds } = props;
    const iconUrl = useMemo(() => getPaymentMethodIconUrl(methodData), [methodData]);
    const displayName = useMemo(() => getPaymentMethodDisplayName(methodData), [methodData]);
    const containerClass = useMemo(
        () =>
            cx(styles.container, {
                [styles.containerDisabled]: !isMethodEnabled,
            }),
        [isMethodEnabled],
    );

    const onContainerClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            if (!isMethodEnabled) {
                return;
            }
            onClick();
        },
        [isMethodEnabled, onClick],
    );

    return (
        <div className={containerClass} onClick={onContainerClick} data-testid={testIds.CONTAINER}>
            <PaymentMethodIcon
                src={iconUrl}
                parentClassName={styles.containerIconContainer}
                imgClassName={styles.containerIconContainerImage}
                data-testid={testIds.ICON}
            />
            <PaymentMethodName
                displayName={displayName}
                enabled={isMethodEnabled}
                data-testid={testIds.NAME}
                className={styles.containerTitle}
            />
        </div>
    );
}

export default memo(PaymentMethodIconView);
